module.exports = __webpack_public_path__ + "img/入会打榜.24d4610b.svg";